export default function getFontConfig(l: number, mapViewSettings: any) {
  let sCode = mapViewSettings.sCode === 'On' ? 10 : 0
  let sName = mapViewSettings.sName === 'On' ? 12 : 0
  let mrName = 10
  let eName = mapViewSettings.eName === 'On' ? 10 : 0
  let ePhone = mapViewSettings.ePhone === 'On' ? 10 : 0
  let label = 10

  if (l > 100) {
    sCode = 14
    eName = 16
    ePhone = 14
    mrName = 18
    sName = 16
    label = 16
  } else if (l > 50) {
    sCode = 12
    eName = 14
    mrName = 16
    sName = 14
    label = 14
  } else if (l > 35) {
    sCode = 10
    eName = 10
    mrName = 14
    sName = 14
    label = 14
  } else if (l > 20) {
    sCode = 10
  }

  return {
    sCode: mapViewSettings.sCode === 'Off' ? 0 : sCode,
    sName: mapViewSettings.sName === 'Off' ? 0 : sName,
    mrName: mapViewSettings.mrName === 'Off' ? 0 : mrName,
    eName: mapViewSettings.eName === 'Off' ? 0 : eName,
    ePhone: mapViewSettings.ePhone === 'Off' ? 0 : ePhone,
    label: mapViewSettings.label === 'Off' ? 0 : label,
  }
}
